var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ofType, combineEpics } from "redux-observable";
import { mergeMap, filter } from "rxjs/operators";
import { of, from } from "rxjs";
import AnalysisResources from "../../module/AnalysisResources.js";
import logger from "@ane/core/lib/services/logging/Logger";
import { getCompletedAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { studyAbstractsV2MainFunctionality, studyAbstractV2MainFunctionality, studyTaskV2MainFunctionality, forayMetadataMainFunctionality, stepMetadataMainFunctionality } from "../ducks/AnalysisStudyLogPerformanceActions.js";
import { loadingV2StudyAbstractsForStepId, loadedWorkspaceSplitRedirect, loadedV2StudyAbstractsForStepId, loadingV2StudyAbstract, loadedV2StudyAbstract, loadingV2TaskLogs, loadedV2TaskLogs, loadingTaskOverviewInfoForScorecardId, loadedTaskOverviewInfoForScorecardId, loadedStudy, loadingStudy, loadedStudiesForStepId, loadingForayConfigMetadata, loadedForayConfigMetadata, registeringAnalysisForStepId, registeredAnalysisForStepId, gettingRawStudy, loadedRawStudy, loadingAnalysisStepProperties, loadedAnalysisStepProperties } from "../ducks/AnalysisStudyListActions.js";
import AnalysisStudyListConstants from "../ducks/AnalysisStudyListConstants.js";
import { getStudyFromRawStudy } from "../utils/AnalysisStudyUtils.js";
import * as _ from "lodash";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { isDataReady } from "@ane/core/lib/services/RestServiceBase";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { convertScorecardRequestToTaskOverview } from "../utils/AnalysisTaskUtils.js";
import { convertToV2StudyAbstract } from "../../utils/ContractConverterUtils.js";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
const prefix = "AnalysisView";
const getV2StudyAbstractsForStepIdEpicArgs = {
  filterOnType: AnalysisStudyListConstants.V2_LOAD_STUDY_ABSTRACTS_FOR_STEP_ID,
  loadResource: (payload, state) => AnalysisResourceV2.getAnalyses(payload.workspaceId, payload.stepId),
  loadingAction: (payload) => loadingV2StudyAbstractsForStepId(payload.stepId),
  loadedAction: (successData, payload, error = "", errorContext) => {
    var _a;
    if ((errorContext == null ? void 0 : errorContext.statusCode) === 301) {
      return of(
        loadedWorkspaceSplitRedirect({
          workspaceRedirect: getCompletedAsyncWrapperObj(successData, error)
        })
      );
    }
    const v2StudyAbstracts = ((_a = successData == null ? void 0 : successData.value) == null ? void 0 : _a.map((analysis) => {
      var _a2;
      return convertToV2StudyAbstract(analysis, (_a2 = successData["@count"]) != null ? _a2 : 0);
    })) || [];
    logger.trackMetric({
      average: v2StudyAbstracts == null ? void 0 : v2StudyAbstracts.length,
      name: `AnalysisManagement:StudyListResultCount`,
      properties: {}
    });
    return of(
      studyAbstractsV2MainFunctionality({
        clientTimeInMs: performance.now(),
        isCached: false
      }),
      loadedV2StudyAbstractsForStepId(payload.stepId, {
        isLoading: false,
        data: v2StudyAbstracts,
        error
      })
    );
  },
  dontLoad: (payload, state) => {
    if (payload.invalidateCache) {
      return false;
    }
    const abstracts = state && state.analysisStudyList.v2StudyAbstractsByStepId[payload.stepId];
    const dontLoad = abstracts && (isDataReady(abstracts) || abstracts.isLoading);
    if (!dontLoad) {
      return false;
    } else {
      return !!abstracts && !!abstracts.data ? of(
        studyAbstractsV2MainFunctionality({
          clientTimeInMs: performance.now(),
          isCached: true
        })
      ) : true;
    }
  }
};
const getV2StudyAbstractsForStepIdEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(
  getV2StudyAbstractsForStepIdEpicArgs
);
const getV2StudyAbstractEpicArgs = {
  filterOnType: AnalysisStudyListConstants.V2_LOAD_STUDY_ABSTRACT,
  loadResource: (payload, state) => AnalysisResourceV2.getAnalysis(payload.workspaceId, payload.studyId),
  loadingAction: (payload) => loadingV2StudyAbstract(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    var _a;
    if ((errorContext == null ? void 0 : errorContext.statusCode) === 301) {
      return of(
        loadedWorkspaceSplitRedirect({
          workspaceRedirect: getCompletedAsyncWrapperObj(successData, error)
        })
      );
    }
    if (!!error) {
      return of(
        studyAbstractV2MainFunctionality({
          clientTimeInMs: performance.now(),
          isCached: false
        }),
        loadedV2StudyAbstract({
          params: payload,
          result: {
            data: null,
            status: AsyncRequestStatus.Failed,
            error,
            errorContext
          }
        })
      );
    }
    const v2StudyAbstract = convertToV2StudyAbstract(successData == null ? void 0 : successData.value);
    logger.trackMetric({
      average: ((_a = v2StudyAbstract == null ? void 0 : v2StudyAbstract.AnalysisTaskAbstracts) == null ? void 0 : _a.length) || 0,
      name: `AnalysisManagement:StudyTaskListResultCount`,
      properties: {}
    });
    return of(
      studyAbstractV2MainFunctionality({ clientTimeInMs: performance.now(), isCached: false }),
      loadedV2StudyAbstract({
        params: payload,
        result: {
          data: v2StudyAbstract,
          status: AsyncRequestStatus.Completed,
          error,
          errorContext
        }
      })
    );
  },
  dontLoad: (payload, state) => {
    var _a, _b;
    if (!state) {
      return false;
    }
    if (payload.invalidateCache) {
      return false;
    }
    const dontLoad = !!((_b = (_a = state.analysisStudyList.v2StudyEachAbstractByStepAndStudyId[payload.stepId]) == null ? void 0 : _a[payload.studyId]) == null ? void 0 : _b.data);
    return dontLoad ? of(
      studyAbstractV2MainFunctionality({
        clientTimeInMs: performance.now(),
        isCached: true
      })
    ) : false;
  }
};
const getV2StudyAbstractEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getV2StudyAbstractEpicArgs);
const getV2TaskLogsForTaskIdEpicArgs = {
  filterOnType: AnalysisStudyListConstants.V2_LOAD_TASK_LOGS,
  loadResource: (payload, state) => AnalysisResources.getV2TaskLogsForTaskId(payload.taskId),
  loadingAction: (payload) => loadingV2TaskLogs(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    if ((errorContext == null ? void 0 : errorContext.statusCode) === 301) {
      return of(
        loadedWorkspaceSplitRedirect({
          workspaceRedirect: getCompletedAsyncWrapperObj(successData, error)
        })
      );
    }
    return of(
      studyTaskV2MainFunctionality({ clientTimeInMs: performance.now(), isCached: false }),
      loadedV2TaskLogs(__spreadProps(__spreadValues({}, payload), { v2TaskLogEntries: successData }))
    );
  },
  dontLoad: (payload, state) => {
    const logs = state && state.analysisStudyList.v2TaskLogEntriesByTaskId[payload.taskId];
    const dontLoad = logs && (isDataReady(logs) || logs.isLoading);
    if (!dontLoad) {
      return false;
    } else {
      return !!logs && !!logs.data ? of(
        studyTaskV2MainFunctionality({
          clientTimeInMs: performance.now(),
          isCached: true
        })
      ) : true;
    }
  }
};
const getV2TaskLogsForTaskIdEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getV2TaskLogsForTaskIdEpicArgs);
const getTaskOverviewInfoForScorecardIdArgs = {
  filterOnType: AnalysisStudyListConstants.LOAD_TASK_OVERVIEW_INFO_FOR_SCORECARDID,
  loadResource: (payload, state) => AnalysisResourceV2.getScorecardRequest(payload.workspaceId, payload.scorecardId),
  loadingAction: (payload) => loadingTaskOverviewInfoForScorecardId(payload),
  loadedAction: (successData, payload, error) => {
    return of(
      loadedTaskOverviewInfoForScorecardId(__spreadProps(__spreadValues({}, payload), {
        taskOverviewInfo: convertScorecardRequestToTaskOverview(successData),
        error
      }))
    );
  }
};
const getTaskOverviewInfoForScorecardIdEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(
  getTaskOverviewInfoForScorecardIdArgs
);
const concurrentRequests = 32;
const getStudies = (studyIds, state$) => {
  return from(studyIds).pipe(
    mergeMap((studyId) => {
      const args = {
        payload: studyId,
        loadResource: (payload, state) => AnalysisResources.getStudy(payload),
        state$,
        loadedAction: (successData, payload, errorMsg) => {
          if (errorMsg) {
            throw errorMsg;
          }
          const study = getStudyFromRawStudy(successData);
          return of(loadedStudy(study.Id, study));
        },
        loadingAction: (payload) => loadingStudy(payload),
        dontLoad: (payload, state) => {
          const study = state && state.analysisStudyList.studies[studyId];
          return !!study && (!!study.data || study.isLoading);
        }
      };
      return ReduxObservablesEpicUtils.innerLoadLoadingLoadedEpic(args);
    }, concurrentRequests)
  );
};
const getStudiesForStudyIds = (action$, state$) => {
  return action$.pipe(
    ofType(AnalysisStudyListConstants.LOAD_STUDIES_FOR_STUDY_IDS),
    mergeMap((value) => getStudies(value.payload, state$))
  );
};
const getStudyForStudyId = (action$, state$) => {
  return action$.pipe(
    ofType(AnalysisStudyListConstants.LOAD_STUDY_FOR_STUDY_ID),
    filter((value) => !!value.payload),
    mergeMap((value) => getStudies([value.payload], state$))
  );
};
const checkStudyLoadComplete = (action$, state$) => {
  return action$.pipe(
    ofType(AnalysisStudyListConstants.LOADED_STUDY, AnalysisStudyListConstants.LOADING_STUDY_ABSTRACTS_FOR_STEP_ID),
    filter(
      (value) => _.keys(state$.value.analysisStudyList.studies).length > 0 && _.every(state$.value.analysisStudyList.studies, (s) => !s.isLoading && (!!s.data || !!s.error))
    ),
    mergeMap((value) => of(loadedStudiesForStepId()))
  );
};
const getForayConfigMetadataArgs = {
  filterOnType: AnalysisStudyListConstants.LOAD_FORAY_CONFIG_METADATA,
  loadResource: (payload, state) => AnalysisResources.getForayConfigMetadata(),
  loadingAction: (store) => loadingForayConfigMetadata(),
  loadedAction: (successData) => of(
    forayMetadataMainFunctionality({ clientTimeInMs: performance.now(), isCached: false }),
    loadedForayConfigMetadata(successData)
  ),
  dontLoad: (payload, state) => {
    var _a;
    const forayConfigMetadata = (_a = state == null ? void 0 : state.analysisStudyList) == null ? void 0 : _a.forayConfigMetadata;
    const dontLoad = forayConfigMetadata && (isDataReady(forayConfigMetadata) || forayConfigMetadata.isLoading);
    if (!dontLoad) {
      return false;
    } else {
      return !!forayConfigMetadata && !!forayConfigMetadata.data ? of(
        forayMetadataMainFunctionality({
          clientTimeInMs: performance.now(),
          isCached: true
        })
      ) : true;
    }
  }
};
const getForayConfigMetadata = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getForayConfigMetadataArgs);
const registerAnalysisArgs = {
  filterOnType: AnalysisStudyListConstants.REGISTER_ANALYSIS_FOR_STEP,
  loadResource: (payload, state) => AnalysisResourceV2.registerAnalysis(payload.workspaceId, payload.stepId),
  loadingAction: (store) => registeringAnalysisForStepId(),
  loadedAction: (successData, payload, error) => of(registeredAnalysisForStepId(getCompletedAsyncWrapperObj("Done", error))),
  dontLoad: (payload, state) => {
    return false;
  }
};
const registerAnalysisEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(registerAnalysisArgs);
const getRawStudyArgs = {
  filterOnType: AnalysisStudyListConstants.LOAD_RAW_STUDY,
  loadResource: (payload, state) => AnalysisResources.getStudy(payload.studyId),
  loadingAction: (payload) => gettingRawStudy(payload),
  loadedAction: (successData, payload, error) => of(
    loadedRawStudy({
      studyId: payload.studyId,
      rawStudy: getCompletedAsyncWrapperObj(successData, error)
    })
  ),
  dontLoad: (payload, state) => {
    return false;
  }
};
const getRawStudyEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getRawStudyArgs);
const loadExperimentStepPlanSummaryEpicReducerArg = {
  actionPrefix: `${prefix}/loadExperimentStepPlanSummary`,
  reduxKeyNested: () => ["experimentStepPlanSummaryAsync"],
  loadResource: (inputPayload) => AnalysisResources.getExperimentStepPlanSummary(inputPayload.stepId),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadExperimentStepPlanSummaryEpicReducer = loadResourcesUtils(loadExperimentStepPlanSummaryEpicReducerArg);
const getAnalysisStepPropertiesArgs = {
  filterOnType: AnalysisStudyListConstants.LOAD_ANALYSIS_STEP_PROPERTIES,
  loadResource: (payload, state) => AnalysisResources.getAnalysisStepProperties(payload),
  loadingAction: () => loadingAnalysisStepProperties(),
  loadedAction: (successData, payload, error = "") => {
    return of(
      stepMetadataMainFunctionality({ clientTimeInMs: performance.now(), isCached: false }),
      loadedAnalysisStepProperties({
        data: successData,
        error,
        isLoading: false
      })
    );
  },
  dontLoad: (payload, state) => {
    var _a, _b, _c;
    const analysisStepProperties = (_a = state == null ? void 0 : state.analysisStudyList) == null ? void 0 : _a.analysisStepProperties;
    const dontLoad = compareIgnoreCase((_c = (_b = analysisStepProperties == null ? void 0 : analysisStepProperties.data) == null ? void 0 : _b.Id) != null ? _c : "", payload) && (analysisStepProperties == null ? void 0 : analysisStepProperties.isLoading) == false || (analysisStepProperties == null ? void 0 : analysisStepProperties.isLoading) == true || !!(analysisStepProperties == null ? void 0 : analysisStepProperties.error);
    if (!dontLoad) {
      return false;
    } else {
      return !!analysisStepProperties && !!analysisStepProperties.data ? of(
        stepMetadataMainFunctionality({
          clientTimeInMs: performance.now(),
          isCached: true
        })
      ) : true;
    }
  }
};
const getAnalysisStepProperties = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getAnalysisStepPropertiesArgs);
const analysisStudyListEpics = combineEpics(
  loadExperimentStepPlanSummaryEpicReducer.epic,
  getV2StudyAbstractsForStepIdEpic,
  getV2StudyAbstractEpic,
  getV2TaskLogsForTaskIdEpic,
  getTaskOverviewInfoForScorecardIdEpic,
  getStudiesForStudyIds,
  getStudyForStudyId,
  checkStudyLoadComplete,
  getForayConfigMetadata,
  getAnalysisStepProperties,
  getRawStudyEpic,
  registerAnalysisEpic
);
export {
  analysisStudyListEpics,
  checkStudyLoadComplete,
  getAnalysisStepProperties,
  getForayConfigMetadata,
  getRawStudyEpic,
  getStudiesForStudyIds,
  getStudyForStudyId,
  getTaskOverviewInfoForScorecardIdEpic,
  getV2StudyAbstractEpic,
  getV2StudyAbstractsForStepIdEpic,
  getV2TaskLogsForTaskIdEpic,
  loadExperimentStepPlanSummaryEpicReducer,
  registerAnalysisEpic
};
//# sourceMappingURL=AnalysisStudyListEpic.js.map
